import { FunctionComponent, Suspense } from "react";
import { Redirect, Route, RouteProps, useLocation } from "react-router";

import useAppContext from "@src/modules/App/hooks/useAppContext";
import { redirectToQueryParam } from "@src/modules/Public/shared/LoginForm/LoginForm";
import routesPaths from "@src/modules/Routing/routesPaths";
import ScreenLoading from "@src/modules/shared/components/ScreenLoading";

type Props = RouteProps & Required<Pick<RouteProps, "component">>;

export const AuthedRoute: FunctionComponent<Props> = ({
  component: Component,
  ...routeProps
}) => {
  const location = useLocation();

  // token means that user is logged in
  const hasToken = !!useAppContext().userToken;

  if (!hasToken) {
    return (
      <Redirect
        to={{
          pathname: routesPaths.LOGIN,
          search: new URLSearchParams({
            [redirectToQueryParam]: location.pathname + location.search,
          }).toString(),
        }}
      />
    );
  }

  return (
    <Route
      {...routeProps}
      render={(routeComponentProps) => (
        <Suspense fallback={<ScreenLoading />}>
          <Component {...routeComponentProps} />
        </Suspense>
      )}
    />
  );
};
export default AuthedRoute;
